import React, { useEffect } from 'react'
import getTranslation from '../../TranslationUtility/TranslationUtility';
import { UserIdAndStatusData } from '../../Utility/Utility';
import { callBannerAuditApi } from '../../Context/bannerAuditApi';

const DisclaimerPopup = ({
    onClose,
    isOpen,
    bannerData,
    isMobileView
}) => {
    const translation = getTranslation();

    const { userId, userStatus, customerIdentifier } = UserIdAndStatusData();
    // Lock background scroll while open. `body { overflow: hidden }` doesn't work here: html has
    // its own `overflow-y: scroll` (LuxuryPopup.scss), so the body's overflow never reaches the
    // viewport and the page kept scrolling behind the popup. Pinning the body in place does —
    // same approach as LuxuryPopup — and leaves the scrollbar track alone, so nothing shifts.
    useEffect(() => {
        if (!isOpen) return;
        const { body } = document;
        const scrollY = window.scrollY;
        const previous = {
            position: body.style.position,
            top: body.style.top,
            width: body.style.width,
        };
        body.style.position = "fixed";
        body.style.top = `-${scrollY}px`;
        body.style.width = "100%";
        return () => {
            body.style.position = previous.position;
            body.style.top = previous.top;
            body.style.width = previous.width;
            window.scrollTo(0, scrollY);
        };
    }, [isOpen]);

    const onProceed = () => {
        const redirectUrl = isMobileView ? bannerData?.mobCta : bannerData?.cta;
        callBannerAuditApi({
            SectionId: bannerData?.sectionMasterId,
            SectionContentId: bannerData?.id,
            CustomerId: customerIdentifier || null,
            JourneyType: userStatus === "logged_in" ? "LOGGED_IN" : "NON_LOGGED_IN",
            RedirectUrl: redirectUrl || null,
        }).catch((ex) => { console.error("Error in banner audit api", ex) });
        onClose();
        window.open(redirectUrl, "_blank");
    };
    return (
        <>
            {isMobileView ?
                <>
                    <div
                        className={`fixed inset-0 bg-black bg-opacity-50 z-40 ${isOpen ? 'fade-in' : 'fade-out'}`}
                        onClick={onClose}
                    ></div>
                    <div className="fixed bottom-0 left-0 right-0 w-full rounded-t-3xl shadow-lg overflow-hidden z-50 " style={{ maxHeight: '80vh' }}>
                        <div className={`bg-white rounded-t-2xl w-full shadow-lg flex flex-col overflow-hidden ${isOpen ? 'slide-in-bottom' : 'slide-out-bottom'}`} style={{ maxHeight: '80vh' }}>
                            <div className="flex items-center justify-between sticky top-0 z-10 w-full p-4">
                                <div className="disclaimer-heading">{bannerData?.disclaimerHeading}</div> {/* This will be on the left */}
                                <button className="text-gray-600 text-2xl" onClick={onClose}>
                                    <i className="fas fa-times"></i> {/* This will be on the right */}
                                </button>
                            </div>
                            <hr></hr>
                            <div className="overflow-y-auto flex-1 disclaimer-content ">
                                <div dangerouslySetInnerHTML={{ __html: bannerData?.disclaimerContent }}></div>
                            </div>
                            <hr></hr>
                            <div className="disclaimer-popup-bottom">
                                <button className="text-white " onClick={onProceed}>
                                    {translation?.disclaimerProcessBtn}
                                </button>
                            </div>
                        </div>
                    </div>
                </> :
                <>
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40 flex items-center justify-center"
                        onClick={onClose}
                    >
                        <div
                            className="flex flex-col overflow-hidden disclaimer-web-popup"
                            style={{ maxHeight: '80vh' }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex items-center justify-between w-full p-4 flex-shrink-0">
                                <div className="disclaimer-heading">{bannerData?.disclaimerHeading}</div>
                                <button className="text-gray-500 text-xl leading-none" onClick={onClose}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>
                            <hr className="flex-shrink-0"></hr>
                            <div className="overflow-y-auto flex-1 disclaimer-content">
                                <div dangerouslySetInnerHTML={{ __html: bannerData?.disclaimerContent }}></div>
                            </div>
                            <hr className="flex-shrink-0"></hr>
                            <div className="flex justify-end disclaimer-popup-bottom flex-shrink-0">
                                <button className="text-white" onClick={onProceed}>
                                    {translation?.disclaimerProcessBtn}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            }
        </>
    );
};


export default DisclaimerPopup